<template>
    <client-page class="wrap--mypage">
        <v-container>
                <div class="mypage-container">
                    <!-- 네비게이션 메뉴 -->
                    <mypage-navigation />
                    <!-- 페이지 콘텐츠 -->
                    <div class="mypage-contents">
                        <div class="tit-wrap tit-wrap--unberline">
                            <h2 class="tit">위탁신청</h2>
                        </div>

                        <form-input code="consignment-sale" skin="consignment-sale"></form-input>
                    </div>
                </div>
        </v-container>
    </client-page>
</template>

<script>
import FormInput from "@/components/client/form/form-input.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MypageNavigation from "@/components/client/mypage-navigation.vue";

export default {
    components: {
        FormInput,
        ClientPage,
        MypageNavigation,
    },
};
</script>
